import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationService } from './location.service';
import { CapactitorLocationService } from './logic/capacitor-location.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: LocationService,
      useClass: CapactitorLocationService
    }
  ]
})
export class LocationModule {}
